import createAPI from "@/common/createApi.js"
/**
 * config: 接口参数，
 * vconfig: （自定义参数）{
 *  neverLoading: 是否显示loading
 * }
 */
export default {
  // 查看账户列表
  getRealmsUsers: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/users`, "get", config),
  // 查看账户信息
  getRealmsUserById: (realmName, userID, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/users/${userID}`,
      "get",
      config
    ),
  // 更新账户信息
  putRealmsUserById: (realmName, userID, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/users/${userID}`,
      "put",
      config
    ),
  // 更新账户信息
  _putRealmsUserById: (realmName, userID, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/users/${userID}`,
      "put",
      config,
      {
        neverLoading: true
      }
    ),
  // 删除账户信息
  deleteRealmsUserById: (realmName, userID, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/users/${userID}`,
      "delete",
      config
    ),
  // 添加账户信息
  postRealmsUsers: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/users`, "post", config),
  // 重置账户密码
  putResetPassword: (realmName, userID, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/users/${userID}/reset-password`,
      "put",
      config
    ),
  // 获取用户没选择的所有应用下的所有角色
  getAllRoles: (realmName, userId, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/users/${userId}/clients/roles`,
      "get",
      config
    ),
  // 给用户添加角色
  postUserRoles: (realmName, userId, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/users/${userId}/roles`,
      "post",
      config
    ),
  // 获取用户已分配的用户角色
  getUserRoles: (realmName, userId, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/users/${userId}/roles`,
      "get",
      config
    ),
  // 删除用户的角色
  deleteUserRole: (realmName, userId, clientId, rolemark, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/users/${userId}/clients/${clientId}/roles/${rolemark}`,
      "delete",
      config
    ),
  // portal获取账户信息
  getPortalAccountInfo: (realmName, username, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/users/${username}/info`,
      "get",
      config
    ),
  // 获取用户授权信息列表
  getUserClients: (realmName, userId, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/users/${userId}/clients/roles`,
      "get",
      config
    ),
  // 账户授权/取消授权应用
  putUserClients: (realmName, userId, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/users/${userId}/clients`,
      "put",
      config
    ),
  // 账户添加/移除客户端角色
  putUserClientRoles: (realmName, userId, id, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/users/${userId}/clients/${id}/roles`,
      "put",
      config
    ),
  // portal修改密码
  putPortalUpdatePassword: (realmName, username, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/users/${username}/update-password`,
      "put",
      config
    ),
    // 获取账户组信息列表
  getHasGroupList: (realmName, userId, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/users/${userId}/assigned/groups`,
      "get",
      config
    ),
   // 获取账户已分配的组信息列表
   getGroupList: (realmName, userId, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/users/${userId}/groups`,
      "get",
      config
    ),
    // 给账户分配组
   addGroup: (realmName, userId, config) =>
    createAPI(
      `/idaas/admin/realms/${ realmName }/users/${ userId }/groups`,
      "put",
      config
    ),
    // 修改用户名
   changeUserName: (realmName, username, config) =>
    createAPI(
      `/idaas/admin/realms/${ realmName }/users/${ username }/update-fullName/`,
      "put",
      config
    ),
    // 修改绑定手机号/邮箱 changeType: update-phone/update-email
   changeNumber: (realmName, username, changeType, config) =>
    createAPI(
      `/idaas/admin/realms/${ realmName }/users/${ username }/${ changeType }`,
      "put",
      config
    ),
    // 发送验证码 sendType: send-phone, send-email
   sendCode: (realmName, sendType, config) =>
    createAPI(
      `/idaas/admin/realms/${ realmName }/send/${ sendType }/`,
      "post",
      config
    ),
   // 个性化设置上传图片
   uploadImg:  (realmName, clientId, config) =>
    createAPI(`/idaas/admin/realms/${ realmName }/login?client=${ clientId }`, "put", config),
    // 获取个性化设置
   getConfig:  (realmName, clientId) =>
    createAPI(`/idaas/admin/realms/${ realmName }/login?client=${ clientId }`, "get"),
  // 获取个性化删除
   deleteImg:  (realmName, clientId, filePath, fileParam) =>
    createAPI(`/idaas/admin/realms/${ realmName }/login?client=${ clientId }&filePath=${ filePath }&fileParam=${ fileParam }`, "DELETE"),
    // 绑定
   bindRender:  (source, config) =>
    createAPI(`/idaas/oauth/render/${ source }`, "get", config),
    // 绑定h回调接口
   bindCallBack:  (source, url, realmName, config) =>
    createAPI(`/idaas/oauth/callback/${ source }?url=${url}&realmName=${realmName}`, "post", config),
    // 绑定orcid 微信
    bindAccount:  (realmName, providerId, config) =>
    createAPI(`/idaas/idP/admin/realms/${ realmName }/identity-provider/${ providerId }/link`, "post", config),
    // 解绑微信 orcid
   deleteProvid:  (realmName, providerId, config) =>
    createAPI(`/idaas/idP/admin/realms/${ realmName }/identity-provider/${ providerId }/link`, "delete", config),
}
